import * as React from 'react';
import { TranslationFunction } from '../../types';
import icons from '../../icons';
import LoadingAnimation from '../../components/LoadingAnimation';
import Modal from '../../components/Modal';

const EducationCards = React.lazy(() => import(/* webpackChunkName: EducationCards */ './EducationCards'));

interface EducationCardsModalProps {
    translate: TranslationFunction;
    showByDefault: boolean;
}

const EducationCardsModal: React.FunctionComponent<EducationCardsModalProps> = ({ translate, showByDefault }) => {
    const renderInnerContent = (handleToggleVisibility: () => void) => <React.Suspense fallback={<LoadingAnimation />}><EducationCards handleCloseModal={handleToggleVisibility} translate={translate} /></React.Suspense>;

    return (
        <Modal
            innerContent={renderInnerContent}
            contentClassName="modal--educationCards"
            showByDefault={showByDefault}
        >
            {({ handleToggleVisibility }) => (
                <a className="educationModal__toggle" onClick={handleToggleVisibility}>
                    <span className="educationModal__icon">{icons.questionMark}</span>
                    <span className="educationModal__label">{translate('help')}</span>
                </a>
            )}
        </Modal>
    );
};

export default EducationCardsModal;



// WEBPACK FOOTER //
// ./src/sections/EducationCards/EducationCardsModal.tsx